
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plasmids/[setID]/[plasmidID]",
      function () {
        return require("private-next-pages/plasmids/[setID]/[plasmidID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plasmids/[setID]/[plasmidID]"])
      });
    }
  